module.exports = __webpack_public_path__ + "static/media/LoriWaltenburyPhoto_R5_7431.be21b1e7.jpg";